import {
    AuthenticationSettingType,
    BulkAuthenticationSettingKey,
} from '../../services/identity/AuthenticationSettingService';
import { useCheckAuthenticationSetting } from './useCheckAuthenticationSetting';

export const useCheckSSOEnabled = () => {
    const bulkAuthenticationSetting = useCheckAuthenticationSetting();
    const isSSOEnabled = !!(bulkAuthenticationSetting?.[BulkAuthenticationSettingKey.AAD] || bulkAuthenticationSetting?.[BulkAuthenticationSettingKey.SAML]);
    const isAADEnabled = bulkAuthenticationSetting?.[BulkAuthenticationSettingKey.AAD]?.authenticationSettingType?.toLowerCase() === AuthenticationSettingType.AAD;
    const isSAMLEnabled = bulkAuthenticationSetting?.[BulkAuthenticationSettingKey.SAML]?.authenticationSettingType?.toLowerCase() === AuthenticationSettingType.SAML;
    return {
        isSSOEnabled,
        isAADEnabled,
        isSAMLEnabled,
    };
};
